import {
  GetAddressDetailsList,
  AddAdderessListProps,
  CountryLookUpDTO,
} from '../../../../types/Invoicing/AdderessList/adderesslist'
import {
  getAuthenticatedRequestConfig,
  useAxios,
} from '../../../../utils/apiUtils'
import { AdderessListApiConfig, AllowedHttpMethods } from '../../apiList'

const getAdderessList = async (): Promise<GetAddressDetailsList[]> => {
  const requestConfig = getAuthenticatedRequestConfig({
    url: AdderessListApiConfig.getAddressDetailsList,
    method: AllowedHttpMethods.get,
  })

  const response = await useAxios(requestConfig)
  return response.data
}

const deleteAdderessList = async (addressId: number): Promise<number> => {
  const requestConfig = getAuthenticatedRequestConfig({
    url: AdderessListApiConfig.deleteAddressDetails,
    method: AllowedHttpMethods.delete,
    params: {
      addressId,
    },
  })

  const response = await useAxios(requestConfig)
  return response.data
}

const addAddress = async (
  addAdderessList: AddAdderessListProps,
): Promise<number> => {
  const requestConfig = getAuthenticatedRequestConfig({
    url: AdderessListApiConfig.addAddress,
    method: AllowedHttpMethods.post,
    data: addAdderessList,
  })

  const response = await useAxios(requestConfig)
  return response.data
}
const updateAddress = async (
  updateAdderessList: AddAdderessListProps,
): Promise<number> => {
  const requestConfig = getAuthenticatedRequestConfig({
    url: AdderessListApiConfig.updateAddress,
    method: AllowedHttpMethods.put,
    data: updateAdderessList,
  })

  const response = await useAxios(requestConfig)
  return response.data
}
const getCountryLookup = async (): Promise<CountryLookUpDTO[]> => {
  const requestConfig = getAuthenticatedRequestConfig({
    url: AdderessListApiConfig.getCountryLookup,
    method: AllowedHttpMethods.get,
  })

  const response = await useAxios(requestConfig)
  return response.data
}

const adderessListApi = {
  getAdderessList,
  deleteAdderessList,
  addAddress,
  updateAddress,
  getCountryLookup,
}

export default adderessListApi
